import React, { useState } from 'react'
import styles from './Form.module.css'
import type { FormDataType } from './types.ts'

export default function Form() {
    const [formData, setFormData] = useState<FormDataType>({
        companyName: '',
        contactName: '',
        phoneNumber: '',
        email: '',
        inquiryContent: '',
        consent: false,
    })

    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value, type } = e.target
        const checked = (e.target as HTMLInputElement).checked

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }))
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setIsSubmitting(true)

        try {
            const csrfToken = document.querySelector<HTMLMetaElement>(
                'meta[name="csrf-token"]'
            )?.content
            const inquiryUrl = '/business/inquiry'

            const response = await fetch(inquiryUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken || '',
                },
                body: JSON.stringify({
                    company_name: formData.companyName,
                    contact_name: formData.contactName,
                    phone_number: formData.phoneNumber,
                    email: formData.email,
                    inquiry_content: formData.inquiryContent,
                    consent: formData.consent,
                    is_hotel: false,
                }),
            })

            const data = await response.json().catch(() => ({}))

            if (response.ok && data.success && data.redirect_url) {
                window.location.href = data.redirect_url
                return
            }

            if (response.ok) {
                setFormData({
                    companyName: '',
                    contactName: '',
                    phoneNumber: '',
                    email: '',
                    inquiryContent: '',
                    consent: false,
                })
            } else {
                alert(
                    data.errors?.join('\n') ||
                        'エラーが発生しました。もう一度お試しください。'
                )
            }
        } catch (error) {
            console.error('Error submitting form:', error)
            alert('エラーが発生しました。もう一度お試しください。')
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <section id='form' className={styles.form}>
            <div className={styles.formWidth}>
                <div className={styles.formFirst}>
                    <h2>お問い合わせ</h2>
                    <p>
                        <span className={styles.formPc}>右</span>
                        <span className={styles.formSp}>下</span>
                        のフォームより必要事項、お問い合わせ内容をご入力ください。
                        <span className={styles.br}>
                            1営業日以内に弊社担当者より採用DXプラットフォームについてご案内させていただきます。導入開始後、最短1営業日で求人掲載が可能となります。
                        </span>
                    </p>
                </div>
                <div className={styles.formSecond}>
                    <form onSubmit={handleSubmit} className={styles.mainForm}>
                        <dl>
                            <dt>
                                <span>必須</span>会社名
                            </dt>
                            <dd>
                                <input
                                    type='text'
                                    name='companyName'
                                    placeholder='例）株式会社Foodslabo'
                                    className={styles.organization}
                                    value={formData.companyName}
                                    onChange={handleChange}
                                    required
                                />
                            </dd>
                            <dt>
                                <span>必須</span>担当者名
                            </dt>
                            <dd>
                                <input
                                    type='text'
                                    name='contactName'
                                    placeholder='山田太郎'
                                    className={styles.name}
                                    value={formData.contactName}
                                    onChange={handleChange}
                                    required
                                />
                            </dd>
                            <dt>
                                <span>必須</span>連絡先電話番号
                            </dt>
                            <dd>
                                <input
                                    type='tel'
                                    name='phoneNumber'
                                    placeholder='例）03-1234-5678'
                                    className={styles.tel}
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    required
                                />
                            </dd>
                            <dt>
                                <span>必須</span>メールアドレス
                            </dt>
                            <dd>
                                <input
                                    type='email'
                                    name='email'
                                    placeholder='例）example@example.com'
                                    className={styles.email}
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </dd>
                            <dt>お問い合わせ内容</dt>
                            <dd>
                                <textarea
                                    name='inquiryContent'
                                    value={formData.inquiryContent}
                                    onChange={handleChange}
                                />
                            </dd>
                            <p className={styles.privacy}>
                                プライバシーポリシーに基づいて、本ページにご記入いただいた個人情報につきましては、当社からの回答にて使用させていただきます。個人情報に関するお問い合わせ窓口は
                                <a
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    href='https://cuolega.co.jp/privacy/'
                                >
                                    プライバシーポリシー
                                </a>
                                と
                                <a
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    href='https://cuolega.co.jp/terms/'
                                >
                                    利用規約
                                </a>
                                をお読みくださいませ。
                            </p>
                            <p className={styles.consent}>
                                <label>
                                    <input
                                        className={styles.checkbox}
                                        type='checkbox'
                                        name='consent'
                                        checked={formData.consent}
                                        onChange={handleChange}
                                        required
                                    />
                                    利用規約・プライバシーポリシーに同意する
                                </label>
                            </p>
                            <button
                                type='submit'
                                className={styles.button}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? '送信中...' : '問い合わせる'}
                            </button>
                        </dl>
                    </form>
                </div>
            </div>
        </section>
    )
}
